module.exports = __webpack_public_path__ + "static/me-6a9ff78b7543eebbf62d931a27e698a2.svg";